module.exports = __webpack_public_path__ + "fa-brands-400.svg?04f5ae7184323f298e8f28855c9929c8";